<template>
    <div class="container">
        <div class="inner">
            <div class="title page-title">
                <h3>원장님 소개</h3>
            </div>
            <div class="director-wrap">
                <div class="img">
                    <div>
                        <img src="/src/assets/images/kda_ceo01.png" alt="한국디스플레이아카데미 원장 곽진오"/>
                    </div>
                    <p><span>한국디스플레이아카데미 <b>원장 곽진오</b></span></p>
                </div>
                <div class="txt">
                    <div class="greeting">안녕하십니까? <br>
                        <strong>한국디스플레이아카데미 원장 곽진오</strong>입니다.</div>
                    <p>디스플레이는 단순한 화면을 넘어, 우리의 삶과 산업 전반을 혁신하는 핵심 기술로 자리매김하고 있습니다. 브라운관의 등장 이후 끊임없는 진화를 거쳐, 오늘날에는 OLED, 마이크로 LED, 플렉서블, 롤러블, 투명 디스플레이 등 전례 없는 기술 혁신의 시대로 접어들고 있습니다. 특히 폼팩터의 한계를 뛰어넘는 디스플레이 기술은 스마트폰, 웨어러블, 차량용 전장기기 등 차세대 IT 기기의 형태와 경험을 바꾸는 데 있어 핵심적인 역할을 하고 있습니다.</p>
                    <p>디스플레이 산업은 전기·전자, 화학, 재료, 기계, 소프트웨어 등 다양한 전공 분야가 유기적으로 연결된 융합 산업입니다. 인공지능, 모빌리티, 메타버스, 바이오 등 첨단 기술과의 결합을 통해 새로운 시장과 가치를 끊임없이 창출하고 있으며, 앞으로도 디지털 전환 시대의 중심 인프라로서 무궁무진한 확장 가능성을 지니고 있습니다.</p>
                    <p>이러한 변화 속에서 여러분은 각자의 전공과 역량을 바탕으로 연구개발, 공정기술, 품질관리, 제품디자인, UX 기획, 데이터 분석 등 다양한 진로를 탐색하고, 실무 중심의 전문 인재로 성장할 수 있습니다.</p>
                    <p>디스플레이 아카데미는 여러분이 이러한 가능성을 실현할 수 있도록 실제 산업 환경을 체감하고, 첨단 기술을 경험하며 도전할 수 있는 배움의 장을 제공하고자 합니다. 국내 유일의 OLED 공정 라인 실습, 현직 전문가의 직강, 마이크로 LED와 같은 차세대 기술 실습 교육을 통해 예비 인재는 물론 재직자까지 실질적이고 체계적인 성장을 이끌 수 있는 교육 플랫폼을 구축하였습니다.</p>
                    <p>디스플레이 아카데미는 ‘융합’, ‘실무’, ‘교류’, ‘비전’이라는 네 가지 추진 방향을 바탕으로 산업계와 함께 나아가겠습니다. 앞으로 산업의 미래를 이끌 인재들이 각자의 자리에서 빛날 수 있도록, 디스플레이 아카데미는 든든한 동반자가 되겠습니다.</p>
                    감사합니다.
                    <b><small><strong>한국디스플레이아카데미</strong> 원장</small><strong>곽 진 오</strong></b>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../../../assets/scss/theme";

    .director-wrap {
        display: flex;
        .img {
            position: relative;
            width: 520px;
            height: 640px;
            div {
                width: 100%;
                height: 100%;
                background: #D9D9D9;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
            }
            p {
                position: absolute;
                left: 0;
                bottom: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 40px;
                color: #fff;
                text-align: center;
                @include font-size_xs;
                background: $black_color;
                opacity: 0.7;
            }
        }
        .txt {
            width: 880px;
            margin-left: 40px;

            b {
                display: block;
                text-align:right;
                @include font-size_xl;
                margin-top: 20px;
                small {
                    @include font-size_md;
                    margin-right: 20px;
                    font-size:19px;
                    line-height:30px;
                    strong{
                        font-family: 'Gmarket Sans';
                        color:#3843af;
                          font-size:20.5px;
                        line-height:30px;
                        margin-right:4px;
                    }
                }
            }
            .greeting{
                margin-top:-5px;
                color:#1e1e1e;
                font-weight:400;
                font-size:24px;
                line-height:38px;
                strong{
                    color:#3843af;
                    font-weight:600;
                }
            }
            p{
                color:#1e1e1e;
                font-size:16px;
                font-weight:400;
                font-style:normal;
                text-align:justify;
                line-height:28px;
                margin-bottom:26px;
                margin-top:26px;
               }
        }
    }

    h1 {
        @include font-size_xxl;
    }
</style>
<script setup>
</script>